import { render, staticRenderFns } from "./ImportResult.vue?vue&type=template&id=e9c48c56&"
import script from "./ImportResult.vue?vue&type=script&lang=ts&"
export * from "./ImportResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports